module.exports = __webpack_public_path__ + "img/ptt-describe-white.361358a4.svg";